<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="人员信息" :breadcrumbItem="[{to:'/system/rbac/user',name:'人员信息'}]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      人员信息
      <small>人员信息...</small>
    </h1>
    <!-- end page-header -->
    <panel title="公司人员信息" :noButton="true">
      <button
        type="button"
        class="btn btn-theme btn-xs"
        slot="heading-btn"
        size="small"
        @click="fn_append"
      >
        <Icon type="md-add"></Icon>增加用户
      </button>

      <Card :bordered="false">
        <p slot="title">用户列表</p>
        <div slot="extra">
          <Input
            @on-enter="fn_search_user"
            icon="ios-search"
            placeholder="请输入要查询的用户名,登录代码,email，然后按回车"
            class="m-b-20"
            style="width:400px"
            v-model="searchkey"
          ></Input>
        </div>

        <Table size="small" :columns="columns" :data="userdata">
          <template slot-scope="{ row }" slot="role">
            <span v-for="v in row.roles" :key="v.id">{{v.name}},</span>
          </template>
          <template slot-scope="{ row }" slot="status">
            <strong v-if="row.status ===1 || row.status ==='1'">是</strong>
            <strong v-else>否</strong>
          </template>
          <template slot-scope="{ row }" slot="ismaster">
            <strong v-if="row.ismaster ===1 || row.ismaster ==='1'">是</strong>
            <strong v-else>否</strong>
          </template>

          <template slot-scope="{ row, index }" slot="action">
            <button
              type="button"
              size="small"
              class="btn btn-theme btn-xs"
              style="margin-right: 5px"
              @click="fn_edit(index)"
            >修改</button>

            <Poptip
              transfer
              confirm
              title="确认要重置此用户密码吗?"
              @on-ok="fn_reset_userpasswd(row,index)"
              ok-text="确认"
              cancel-text="取消"
            >
              <button size="small" type="button" class="btn btn-theme btn-xs">重置密码</button>
            </Poptip>
          </template>
        </Table>
      </Card>

      <Drawer
        title="用户[新用户默认密码:123456]"
        v-model="v_edit_flag"
        width="720"
        :mask-closable="true"
        :styles="styles"
      >
        <Form :model="formData" :label-width="100" ref="userForm" :rules="rules">
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="姓名" label-position="top" prop="username">
                <Input v-model="formData.username" placeholder="请输入姓名" />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="邮箱" label-position="top" prop="email">
                <Input v-model="formData.email" type="email" placeholder="请输入邮箱，可以登录" />
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
              <FormItem label="入职日期" label-position="top">
                <DatePicker
                  v-model="dateofentry"
                  type="date"
                  placeholder="please select the date"
                  style="display: block"
                  placement="bottom-end"
                ></DatePicker>
              </FormItem>
            </Col>
          </Row>

          <FormItem label="备注" label-position="top">
            <Input type="textarea" v-model="formData.remarks" placeholder="请输入备注" />
          </FormItem>

          <Row :gutter="32">
            <Col span="12">
              <FormItem label="状态" label-position="top">
                <Select v-model="formData.status">
                  <Option value="0" label="无效">无效</Option>
                  <Option value="1" label="有效">有效</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <FormItem label="角色" label-position="top">
            <CheckboxGroup v-model="roles">
              <Checkbox
                style="margin-right:20px"
                v-for="(item,index) in roleList"
                :key="index"
                :value="item.id"
                :label="item.id"
              >{{item.name}}</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem>
            <font color="red">用户[新用户默认密码:123456]</font>
          </FormItem>
        </Form>
        <div class="demo-drawer-footer">
          <Button class="m-r-10" @click="v_edit_flag = false">取消</Button>
          <Button type="primary" @click="fn_save">保存</Button>
        </div>
      </Drawer>
    </panel>
  </div>
</template>
<script>
import moment from "moment";

import {
  getUserListByDepartId,
  storeUser,
  resetUserPasswdHandler,
  getUserListBySearch
} from "@/api/system/user";
import { getRoleList } from "@/api/system/role";
// import the component

import breadcrumb from "@/components/breadcrumb";
export default {
  props: {
    nameRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "名称不能为空", trigger: "blur" }];
      }
    }
  },
  components: { breadcrumb },
  beforeMount() {
    getRoleList()
      .then(res => {
        this.roleList = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  data() {
    return {
      searchkey: "",
      v_edit_flag: false, //打开编辑框的标志
      roleList: [],

      columns: [
        {
          title: "姓名",
          key: "username",
          width: 100
        },

        {
          title: "邮箱",
          key: "email",
          width: 150
        },
        {
          title: "部门管理员",
          slot: "ismaster",
          width: 100
        },
        {
          title: "入职日期",
          key: "dateofentry",
          width: 120
        },

        {
          title: "角色",
          slot: "role",
          minWidth: 120
        },
        {
          title: "备注",
          key: "remarks",
          minWidth: 120
        },
        {
          title: "状态",
          slot: "status",
          width: 80
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "left",
          fixed: "right"
        }
      ],
      userdata: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      roles: [],
      dateofentry: new Date(),
      formData: {
        id: 0,
        idcardnumber: "",
        logincode: "",
        username: "",
        email: "",
        dateofentry: "",
        remarks: "",
        saveroles: "",
        departid: 0,
        status: "1",
        ismaster: 0,
        businessrole: "",
        isproducer: ""
      }
    };
  },
  mounted() {
    //this.$Message.info("compenpentDitMount");
    //装载数据;
    getUserListByDepartId(0)
      .then(res => {
        if (res.status === 200) {
          this.userdata = res.data;
        }
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  computed: {
    rules() {
      return {
        username: this.nameRules,
        idcardnumber: this.idcardnumberRules,
        logincode: this.logincodeRules,
        departid: this.departidRules,
        businessrole: this.businessroleRule,
        isproducer: this.isproducerRules
      };
    }
  },
  methods: {
    fn_append() {
      this.formData.id = 0;
      this.formData.username = "";
      this.formData.email = "";
      this.dateofentry = new Date();
      this.formData.remarks = "";

      this.formData.status = "1";
      this.formData.departid = 0;
      this.v_edit_flag = true;
    },
    fn_edit(index) {
      this.formData = this.userdata[index];

      console.log(this.formData);
      // 设置用户的角色配置选中的数组
      this.roles = [];
      this.formData.roles.forEach(element => {
        this.roles.push(element.id);
      });

      this.formData.status = this.userdata[index].status.toString();

      this.v_edit_flag = true;
    },

    fn_save() {
      this.formData.dateofentry = moment(this.dateofentry).format("YYYY-MM-DD");
      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.formData.saveroles = JSON.stringify(this.roles);

          storeUser(this.formData)
            .then(res => {
              if (res.data.code === 200) {
                this.v_edit_flag = false;
                this.$Notice.success({
                  title: "通知",
                  desc: res.data.message
                });
              } else {
                this.$Notice.error({
                  title: "失败",
                  desc: res.data.message
                });
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_reset_userpasswd(row, index) {
      resetUserPasswdHandler(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.$Modal.success({
              title: "成功",
              content: res.data.message
            });
          } else {
            this.$Notice.error({
              title: "错误",
              desc: res.data.message
            });
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_search_user() {
      if (this.searchkey.length == 0) return;
      getUserListBySearch(this.searchkey)
        .then(res => {
          this.userdata = res.data;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>
<style>
.demo-split {
  height: 1000px;
  border: 1px solid #dcdee2;
}
.demo-split-pane {
  padding: 10px;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
